export default __webpack_public_path__ + "static/pattern-blue-d233cf12462a3e47726c2156ecbb4f17.jpg";